import script from "./PlanPopular.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanPopular.vue?vue&type=script&setup=true&lang=js"

import "./PlanPopular.vue?vue&type=style&index=0&id=1ee7a886&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ee7a886"]])

export default __exports__